import { useQuery } from "@apollo/client/react";
import { Alert, Button, Group, Text } from "@mantine/core";
import { IconSparkles } from "@tabler/icons-react";
import { graphql } from "gql.tada";
import { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { BANNER_PREFERENCE_KEY } from "./ai-devex-constants";

const ORGANIZATION_APPS_COUNT_QUERY = graphql(`
  query organizationAppsCountForAiDevexBanner {
    organizationApps(page: { first: 1 }) {
      totalCount
    }
  }
`);

const readDismissed = (): boolean => {
  try {
    return window.localStorage.getItem(BANNER_PREFERENCE_KEY) === "true";
  } catch {
    return false;
  }
};

export const AiDevexBanner = () => {
  const { data, loading } = useQuery<any>(ORGANIZATION_APPS_COUNT_QUERY, {
    errorPolicy: "all",
  });
  const [dismissed, setDismissed] = useState<boolean>(readDismissed);

  const hasApps = (data?.organizationApps?.totalCount ?? 0) > 0;

  const onDismiss = useCallback(() => {
    try {
      window.localStorage.setItem(BANNER_PREFERENCE_KEY, "true");
    } catch {
      // Ignore — localStorage may be unavailable (private mode, quota).
      // The banner still closes for the current session via setDismissed.
    }
    setDismissed(true);
  }, []);

  if (loading || dismissed || !hasApps) return null;

  return (
    <Alert
      icon={<IconSparkles size={18} />}
      color="cyan"
      variant="light"
      withCloseButton
      onClose={onDismiss}
      mb="md"
    >
      <Group justify="space-between" wrap="nowrap">
        <Text size="sm">
          <strong>New:</strong> Build on WellPlayed with Claude Code, Cursor,
          ChatGPT, or any MCP-capable AI. Scaffold full projects with OIDC
          auth, CRUD hooks, webhooks, and bots.
        </Text>
        <Button
          size="xs"
          variant="light"
          color="cyan"
          component={Link}
          to="/developer/docs#ai-development"
        >
          Get started
        </Button>
      </Group>
    </Alert>
  );
};
